package com.nonopn.skydome.common.app.utils

// Supported app languages
val SupportedLanguages = listOf("fr", "en", "es", "pt")

fun normalizeLanguage(lang: String): String =
    if (lang in SupportedLanguages) lang else "en"

expect fun setSystemLocale(languageCode: String)

expect fun getSystemLanguage(): String
